import { NetworkType } from '@layerswap/widget-types';
import BN from 'bn.js';
import KnownInternalNames from "../../knownIds";
import { AddressSelectionMode } from "../../types";
export const name = 'Starknet';
const TWO = toBN(2);
const MASK_251 = TWO.pow(toBN(251));
const MASK_221 = TWO.pow(toBN(221));
function removeHexPrefix(hex) {
    return hex.replace(/^0x/, '');
}
function addHexPrefix(hex) {
    return `0x${removeHexPrefix(hex)}`;
}
function addAddressPadding(address) {
    return addHexPrefix(removeHexPrefix(address).padStart(64, '0'));
}
function hasHexPrefix(hex) {
    return hex.startsWith('0x');
}
function toBN(number, base) {
    if (typeof number === 'string' && hasHexPrefix(number) && !base) {
        return new BN(removeHexPrefix(number), 'hex');
    }
    return new BN(number, base);
}
function assertInRange(input, lowerBound, upperBound) {
    try {
        const inputBn = toBN(input);
        if (!inputBn.gte(toBN(lowerBound)) || !inputBn.lt(toBN(upperBound))) {
            return false;
        }
    }
    catch {
        return false;
    }
    return true;
}
/** Validates a Starknet address: value in range [2^221, 2^251) and 0x + 64 hex once padded. */
function validateAndParseAddress(address) {
    if (typeof address !== 'string')
        return false;
    if (!assertInRange(address, MASK_221, MASK_251))
        return false;
    const result = addAddressPadding(address);
    return !!result.match(/^(0x)?[0-9a-fA-F]{64}$/);
}
export class StarknetAddressUtilsProvider {
    constructor() {
        this.providerName = name;
        this.networkType = NetworkType.Starknet;
        this.label = 'Starknet';
        this.selection = AddressSelectionMode.Auto;
    }
    supportsNetwork(network) {
        return (KnownInternalNames.Networks.StarkNetMainnet.includes(network.name) || KnownInternalNames.Networks.StarkNetSepolia.includes(network.name))
            || (KnownInternalNames.Networks.ParadexMainnet.includes(network.name) || KnownInternalNames.Networks.ParadexTestnet.includes(network.name));
    }
    isValidAddress(props) {
        const { address } = props;
        if (!address) {
            return false;
        }
        return validateAndParseAddress(address);
    }
    addressFormat(props) {
        const { address } = props;
        if (!address)
            return '';
        return addAddressPadding(address.toLowerCase());
    }
}
